<template>
  <div class="custom-dialog-header">

    <div class="custom-header">
      <span class="title-text">{{ title }}</span>
      <div class="title-underline"></div>
      <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
        @click="handleClose">
  </div>

  <!-- <div class="header-content">
      <span class="title-text">{{ title }}</span>
      <div class="title-underline"></div>
    </div>
    <div class="header-close" @click="handleClose">
      <i class="el-icon-close close-btn"></i>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'CustomDialogHeader',
  props: {
    title: {
      type: String,
      default: '标题'
    },
    showClose: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
/* 自定义对话框头部样式 */
.custom-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 10px 0;
    
    .title-text {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        position: relative;
    }
    
    .title-underline {
        position: absolute;
        bottom: -5px;
        left: -20px;
        right: -20px;
        height: 1px;
        background: #e7e7e7;
        border-radius: 1px;
    }
    .close-btn {
        width: 20px;
        height: 20px;
        cursor: pointer;
    }
    

}

</style>
